export const data = require('./building.json');
export const landData = require('./land.json');
export const companies = require('./companies.json');
